import React, { useEffect, useState, useCallback } from "react";
import { Layout, Row, Col } from "antd";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import { FaBatteryFull, FaBatteryThreeQuarters, FaBatteryHalf, FaBatteryQuarter, FaBatteryEmpty, FaThermometerHalf, FaTint, FaBars } from 'react-icons/fa';

// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import StorageSuggestionApi from "../../common/Apis/StorageSuggestionApi";
import StorageListApi from "../../common/Apis/StorageListApi";
import StorageSensorApi from "../../common/Apis/StorageSensorApi";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";
const LiveSensor = () => {
  const navigate = useNavigate();
  const { Content } = Layout;

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const SensorApi = localStorage.getItem("SensorApi");

  let isSUPER_ADMIN = false;
  const [StorageInst, setStorage] = React.useState([]);

  function convertTimestamp(dateString) {
    const dateObject = new Date(dateString);

    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    const formattedDate = `Last updated ${dateObject}`;
    return formattedDate;
  }
  const BatteryIcon = ({ percentage }) => {
    let IconComponent;

    if (percentage >= 75) {
      IconComponent = <FaBatteryFull style={{ fontSize: '20px' }} />;
    } else if (percentage >= 50) {
      IconComponent = <FaBatteryThreeQuarters style={{ fontSize: '20px' }} />;
    } else if (percentage >= 25) {
      IconComponent = <FaBatteryHalf style={{ fontSize: '20px' }} />;
    } else if (percentage > 0) {
      IconComponent = <FaBatteryQuarter style={{ fontSize: '20px' }} />;
    } else {
      IconComponent = <FaBatteryEmpty style={{ fontSize: '20px' }} />;
    }

    return IconComponent;
  };
  const BatteryIndicator = ({ percentage }) => (
    <div>
      <BatteryIcon percentage={percentage} />
    </div>
  );
  const [isLoading, setIsLoading] = useState(false);
   


  const getStorageInstruction = useCallback(() => {

    if (!SensorApi) {
      setIsLoading(true);
      getRuntimeConfigs();
    } else {
      setIsLoading(true);
    }
    let headers = {
      Authorization: `Bearer ${SensorApi}`,
      "accept": `application/json`,
    };
    let url2 = `https://api.sync-sign.com/v2/nodes`;
    axios
      .get(url2, {
        headers: headers,
      })
      .then((res2) => {
        console.log(res2?.data)
        setIsLoading(false);
        setStorage(res2?.data?.data)
      })
      .catch((err) => {
        console.log(err);

      });
  }, []);



  const [StorageFilter, setStorageFilter] = React.useState([]);
  const [filteredArray, setfilteredArray] = React.useState([]);
  const getStorage = useCallback(() => {
    StorageSensorApi.ListSensors()
      .then((response) => {
        setStorageFilter(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);  
  const getRuntimeConfigs = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        setRuntimeConfigs(response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG'));

        let url = `https://api.sync-sign.com/v2/oauth/token`;

        axios
          .post(url, {
            "username": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'USER_NAME')[0]?.configValue),
            "password": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PASSWORD')[0]?.configValue),
            "provider": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PROVIDER')[0]?.configValue)

          })
          .then((res) => {
            localStorage.setItem("SensorApi", res?.data?.data?.accessToken);
            let headers = {
              Authorization: `Bearer ${res?.data?.data?.accessToken}`,
              "accept": `application/json`,
            };
            let url2 = `https://api.sync-sign.com/v2/nodes`;
            axios
              .get(url2, {
                headers: headers,
              })
              .then((res2) => {
                console.log(res2?.data)
                setIsLoading(false);
                setStorage(res2?.data?.data)
              })
              .catch((err) => {
                console.log(err);

              });
          })
          .catch((err) => {
            console.log(err);

          });

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

 

  useEffect(() => {
    getStorageInstruction();
    getStorage();
    getRuntimeConfigs();
  }, [getStorageInstruction, getStorage, getRuntimeConfigs]);

  const getTemp = async (nodeId) => {
    try {
      let headers = {
        Authorization: `Bearer ${SensorApi}`,
        accept: `application/json`,
      };
      let url2 = `https://api.sync-sign.com/v2/nodes/${nodeId}/samples?limit=1`;

      const res2 = await axios.get(url2, {
        headers: headers,
      });
      const tempData = {
        time: convertUnixTimestampToTime(res2?.data?.data?.records[0]?.time),
        temp: res2?.data?.data?.records[0]?.data?.tm,
      }
      return tempData;
    } catch (error) {
      console.error(`Error fetching temperature data for nodeId ${nodeId}:`, error);
      return null;
    }
  };
  const formatLastUpdated = (timestamp) => {
    const date = new Date(timestamp);
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const formattedDate = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return `Last updated ${formattedDate} `;
  };

  const convertUnixTimestampToTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000); // Multiply by 1000 to convert seconds to milliseconds
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes} ${period}`;
  };
  const fetchData = async () => {
    try {
      const filteredArray = await Promise.all(
        StorageInst?.map(async (storageItem) => {
          const matchingStorageFilter = StorageFilter.find(
            (secondItem) => secondItem?.sensorDTO?.name === storageItem?.nodeId
          );

          if (matchingStorageFilter) {
            const tempData = await getTemp(storageItem?.nodeId);
            console.log(tempData);

            const newField = tempData?.temp;
            const UpdateNewTime = tempData?.time;
            const storagename = matchingStorageFilter?.storageDTO?.name;

            return {
              ...storageItem,
              newField,
              storagename,
              UpdateNewTime,
            };
          }

          return null;
        })
      );

      const results = filteredArray.filter(Boolean);
      return results;
    } catch (error) {
      console.error("Error fetching and processing data:", error);
      return [];
    }
  };

  fetchData().then((filteredArray) => {
    console.log(filteredArray)
    setfilteredArray(filteredArray);
  });

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ width: "100%" }}>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content style={{ margin: "14px 16px 0", display: 'flex', justifyContent: 'center' }}>

          <Row gutter={12} style={{ width: "80%" }}>
            <Col
              lg={24}
              md={24}
              className={RuntimeConfigs.length === 0 ? "pt-3" : "d-none"}
            > <p style={{ fontSize: '17px' }}>You need to set the API credentials from <Link to={'https://portal.mocreo.com/'} target="_blank">Mocreo</Link>. if you already have them please update <Link to={'/settings/sensor-configurations'}>here</Link>.</p>
            </Col>
            {(filteredArray && RuntimeConfigs.length !== 0) && <>
              {filteredArray.map((item) => (
                <>
                  <Col
                    lg={12}
                    md={12}
                    className="pt-3"
                  >
                    <div >
                      <div className={item?.onlined === true ? 'SensorDiv AlertNotificationNew ' : 'SensorDiv AlertNotificationNew AlertNotificationNew2'} style={{ width: "100%" }}>
                        <div className="container">
                          <div className="text top-left"><p className="pb-0 mb-0" style={{ fontWeight: '500', fontSize: '22px' }}>{item?.nodeId}</p><p style={{ fontSize: '18px' }}>{item?.newField !== null ? (item.newField / 100).toFixed(1) + "'C" : null}<br />Max:  {item?.info?.temperature?.max}'C &nbsp;&nbsp;Min : {item?.info?.temperature?.min}'C</p></div>
                          <div className="text top-right">{item?.onlined === true ? <>
                            <div className="mb-0 pb-0"> <p className="mb-0 pb-0 d-flex"><BatteryIndicator percentage={item?.batteryLevel} />&nbsp;&nbsp;<FaBars style={{ color: '#00a18b', fontSize: '17px' }} /></p> <p style={{ fontWeight: '500', fontSize: '16px' }} className="pb-0 mb-0">{item?.storagename}</p></div>
                          </> : <><div className="pb-0 mb-0" style={{ textAlign: 'end' }}><p className="pb-0 mb-0">Device Offline</p><p style={{ fontWeight: '500', fontSize: '16px' }} className="pb-0 mb-0">{item?.storagename}</p></div></>}</div>
                          <div className="text bottom-left"></div>
                          <div className="text bottom-right">{formatLastUpdated(item?.updatedAt)}{item?.UpdateNewTime}</div>
                        </div>
                      </div>
                    </div>
                  </Col>

                </>
              ))}
            </>
            }

          </Row>

        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default LiveSensor;
